import React from "react";

import { View, StyleSheet } from "react-native";

import {
  Text,
  Header,
  Loading,
  RoleCard,
  GridView,
  SafeLayout,
  ScrollLayout,
  EmployeeCard,
} from "components";

import { sizes, strings } from "assets/constants";
import { sn } from "utils";

import { useGetRoles, useGetEmployees } from "clients/apis";

export default function Organization() {
  const { isLoading: rolesLoading, data: roles } = useGetRoles();
  const { isLoading: employeesLoading, data: employees } = useGetEmployees();

  const _renderContent = () => {
    if (rolesLoading || employeesLoading) {
      return <Loading />;
    }

    return (
      <ScrollLayout contentContainerStyle={{ paddingHorizontal: 0 }}>
        <View style={styles.row}>
          <View style={styles.labelContainer}>
            <Text weight="extraBold">{strings.roles}</Text>
          </View>

          <GridView
            numberOfCol={sn(3, 4, 6, 7)}
            data={[...roles?.data?.data?.items, null] as Array<RoleT>}
            renderItem={(item) => <RoleCard role={item} />}
          />
        </View>

        <View style={styles.row}>
          <View style={styles.labelContainer}>
            <Text weight="extraBold">{strings.employee}</Text>
          </View>

          <GridView
            gridHeight={sn(150)}
            numberOfCol={sn(2, 3, 4, 5)}
            data={[...employees?.data?.data, null] as Array<EmployeeT>}
            renderItem={(item) => (
              <EmployeeCard employee={item} roles={roles?.data?.data?.items} />
            )}
          />
        </View>
      </ScrollLayout>
    );
  };

  return (
    <>
      <Header title={strings.organization} />
      <SafeLayout style={{ paddingHorizontal: 0 }}>
        {_renderContent()}
      </SafeLayout>
    </>
  );
}

const styles = StyleSheet.create({
  top: { flexDirection: "row", flexWrap: "wrap" },

  row: { paddingBottom: 2 * sizes.space },

  labelContainer: { paddingHorizontal: sizes.space },
});
